import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { useSetAtom } from "jotai";

import { QUERY_KEYS } from "../constants";
import useAuth from "../../hooks/useAuth";
import { handleGetProfile } from "../../api-clients/userAccountClient";
import { userProfileAtom } from "../../jotai/atoms/user";

function useUserProfileQuery() {
  const { isLoggedIn } = useAuth();
  const setUserProfile = useSetAtom(userProfileAtom);

  const query = useQuery({
    queryKey: [QUERY_KEYS.USER.PROFILE],
    queryFn: handleGetProfile,
    enabled: isLoggedIn,
  });

  useEffect(() => {
    if (!query.isSuccess) return;
    setUserProfile(query.data);
  }, [query.isSuccess, query.data, setUserProfile]);

  return {
    query,
    userProfile: query.data,
  };
}

export default useUserProfileQuery;
